import React from "react";
import { Trans } from "react-i18next";
import {
  HTMLSelect,
  NumericInput,
  Tag,
  Button,
  Alert,
  Callout,
} from "@blueprintjs/core";
import { DatePicker3, TimePrecision } from "@blueprintjs/datetime2";
import i18next from "i18next";
import i18n from "i18next";

import {
  authenticatedGetFetch,
  authenticatedPostFetch,
} from "../../utils/AuthenticatedFetch";
import { mefMontantStr, getCurrencySymbol } from "../../utils/mef";
import { getSetting } from "../Settings/InstallationSettings";

export default class Exceptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      priceLoading: false,
      price: undefined,
      tarifError: false,
    };

    this.handleInputPrice = this.handleInputPrice.bind(this);
    this.handleInputPlate = this.handleInputPlate.bind(this);
    this.handleInputDate = this.handleInputDate.bind(this);
    this.handleNoInput = this.handleNoInput.bind(this);
    this.handleChoiceChanged = this.handleChoiceChanged.bind(this);
    this.handleinput1TxtChanged = this.handleinput1TxtChanged.bind(this);
    this.handleinput2TxtChanged = this.handleinput2TxtChanged.bind(this);
    this.handleinput1ChoiceChanged = this.handleinput1ChoiceChanged(this);
    this.handleinput2ChoiceChanged = this.handleinput2ChoiceChanged(this);
    this.ExceptionInput = this.ExceptionInput.bind(this);
    this.submitException = this.submitException.bind(this);
  }

  ExceptionInput() {
    if (this.state.selection === -1) return null;

    let input = null;
    if (this.state.selection !== undefined) {
      switch (this.state.selection.type) {
        case 1: // no input
          input = <p>pas de saisie</p>;
          break;

        case 2: // entry date
          input = (
            <div>
              <p>date entree:</p>
              <DatePicker3
                locale={i18next.language}
                value={this.state.inputDate}
                onChange={this.handleInputDate}
                timePrecision={TimePrecision.MINUTE}
              />
            </div>
          );
          break;

        case 3: // price input
          input = (
            <div>
              <Trans>price input</Trans>
              <NumericInput
                defaultValue={0}
                minorStepSize={null}
                stepSize={0.1}
                value={this.state.inputPriceText}
                rightElement={<Tag>{getCurrencySymbol()}</Tag>}
                onValueChange={this.handleInputPrice}
              />
            </div>
          );

          break;
        case 4: // licence plate input
          input = (
            <input
              type="text"
              className="licenseplate"
              maxLength="10"
              placeholder="AB 1234"
              value={this.state.inputPlate}
              onChange={this.handleInputPlate}
            />
          );

          break;
        default: // exception with ticket, not available here
          break;
      }
      return (
        <div>
          {input}
          {this.state.tarifError ? <p>invalid tarif</p> : null}
          <Button
            text={<Trans>send</Trans>}
            disabled={this.state.tarifError}
            loading={this.state.priceLoading}
            onClick={() => {
              if (getSetting("justify barrier opening"))
                this.setState({ alert: true });
              else this.submitException();
            }}
          />
        </div>
      );
    } else return null;
  }

  componentDidMount() {
    if (this.props.eq.general.parc !== undefined)
      authenticatedGetFetch(
        "/exceptions?" +
          new URLSearchParams({
            srv: this.props.eq.general.server,
            parkId: this.props.eq.general.parc,
          }),
        async (res) => {
          this.setState({ list: res, selection: undefined });
        }
      );
  }

  handleInputPrice(valueAsNumber, valueAsString) {
    const isValidPrice = (price) => !isNaN(price) && price >= 0 && price < 1000;
    this.setState(
      {
        inputPriceText: valueAsString,
        inputPrice: valueAsNumber,
        price: (parseFloat(valueAsNumber) * 100).toFixed(2),
        priceLoading: !isValidPrice(valueAsNumber),
      },
      () => {
        const today = new Date();
        const entryDate = new Date(today);
        entryDate.setHours(entryDate.getHours() - 1); // just do like the old SPV ...

        // price is a value given by the user
        // perform a tarif calculation only to get the dls
        authenticatedGetFetch(
          "/tarif/calculate?" +
            new URLSearchParams({
              srv: this.props.eq.general.server,
              tarif: this.state.selection.tarif,
              entry: entryDate.toISOString(),
            }),
          async (res) => {
            if (res["error"] !== undefined)
              this.setState({
                tarifError: true,
                priceLoading: false,
              });
            else
              this.setState({
                tarifError: false,
                priceLoading: !isValidPrice(valueAsNumber),
                dls: new Date(res.limit_exit_date),
              });
          }
        );
      }
    );
  }

  handleInputPlate(event) {
    this.setState({ inputPlate: event.target.value });
  }

  handleInputDate(date) {
    if (date !== null)
      this.setState(
        { inputDate: date, priceLoading: true, price: undefined },
        () => {
          // perform a tarif calculation
          authenticatedGetFetch(
            "/tarif/calculate?" +
              new URLSearchParams({
                srv: this.props.eq.general.server,
                tarif: this.state.selection.tarif,
                entry: date.toISOString(),
              }),
            async (res) => {
              if (res["error"] !== undefined)
                this.setState({
                  tarifError: true,
                  priceLoading: false,
                });
              else
                this.setState({
                  tarifError: false,
                  price: res.amount,
                  priceLoading: false,
                  dls: new Date(res.limit_exit_date),
                });
            }
          );
        }
      );
  }

  handleNoInput() {
    // tarif should be a forfait
    // perform a tarif calculation
    const today = new Date();
    const entryDate = new Date(today);
    entryDate.setHours(entryDate.getHours() - 1); // just do like the old SPV ...

    authenticatedGetFetch(
      "/tarif/calculate?" +
        new URLSearchParams({
          srv: this.props.eq.general.server,
          tarif: this.state.selection.tarif,
          entry: entryDate.toISOString(),
        }),
      async (res) => {
        if (res["error"] !== undefined)
          this.setState({
            tarifError: true,
            priceLoading: false,
          });
        else
          this.setState({
            tarifError: false,
            price: res.amount,
            priceLoading: false,
            dls: new Date(res.limit_exit_date),
          });
      }
    );
  }

  handleinput1ChoiceChanged(selection) {
    try {
      this.setState({ input1Choice: selection.target.value });
    } catch (e) {}
  }

  handleinput1TxtChanged(event) {
    this.setState({ input1Txt: event.target.value });
  }

  handleinput2ChoiceChanged(selection) {
    try {
      this.setState({ input2Choice: selection.target.value });
    } catch (e) {}
  }

  handleinput2TxtChanged(event) {
    this.setState({ input2Txt: event.target.value });
  }

  handleChoiceChanged(selection) {
    try {
      this.setState(
        {
          selection: JSON.parse(selection.target.value),
          inputPrice: 0,
          inputDate: undefined,
        },
        () => {
          if (this.state.selection.type === 1) this.handleNoInput();
          else if (this.state.selection.type === 3)
            this.handleInputPrice(this.state.inputPrice);
        }
      );
    } catch (e) {}
  }

  async submitException() {
    const body = {};
    body.srv = this.props.eq.general.server;
    body.parkId = this.props.eq.general.parc;
    body.deviceId = this.props.eq.general.id;
    body.exceptionId = this.state.selection["id"];
    if (this.state.selection["type"] === 2) body.entry = this.state.inputDate;
    if (this.state.selection["type"] === 3)
      body.price = this.state.inputPrice * 100;
    else if (this.state.price !== undefined) body.price = this.state.price;
    if (this.state.dls !== undefined)
      body.limit_exit_date = this.state.dls.toISOString();

    authenticatedPostFetch("/exception", body);
  }

  render() {
    const options = [];
    options.push({
      value: {},
      label: i18n.t("select an exception to send..."),
    });
    this.state.list.forEach((exception) => {
      options.push({
        value: JSON.stringify(exception),
        label: exception.lbl.replace("\\n", " "),
      });
    });

    return options.length > 0 ? (
      <div>
        <HTMLSelect options={options} onChange={this.handleChoiceChanged} />
        <div className="flexbox-center">
          <this.ExceptionInput />
          {this.state.price !== undefined ? (
            <Tag>
              <div>
                <Trans>price:</Trans> {mefMontantStr(this.state.price)}
              </div>
              {this.state.dls !== undefined ? (
                <div>
                  <Trans>dls:</Trans>{" "}
                  {this.state.dls.toLocaleString(i18next.language)}
                </div>
              ) : null}
            </Tag>
          ) : null}
        </div>
        <Alert
          intent="primary"
          isOpen={this.state.alert}
          onClose={() => this.setState({ alert: false })}
          cancelButtonText={<Trans>cancel</Trans>}
          confirmButtonText={<Trans>send</Trans>}
          icon="help"
          onConfirm={() => this.submitException()}
        >
          <p>
            <Trans>Send exception with price</Trans>{" "}
            {mefMontantStr(this.state.price)} <Trans>to device</Trans>{" "}
            {this.props.eq.general.lbl}
          </p>
          <Callout intent="warning">
            <Trans>
              this action will be registered and visible by the administrator
            </Trans>
          </Callout>
        </Alert>
      </div>
    ) : null;
  }
}
